import { MODAL_ALERT } from "../lib/types";

export const modalAlertActions = ( data ) => ( dispatch ) => {
  dispatch({
    type: MODAL_ALERT,
    payload: data
  });
};



// WEBPACK FOOTER //
// ./src/actions/modal-alert.actions.js